import React, { useEffect, useState, useCallback } from "react";
import { Button } from "primereact/button";
import { Avatar } from "primereact/avatar";
import { Rating } from "primereact/rating";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Timeline } from "primereact/timeline";
import { baseURL } from "../../../Config";
import defaultImg from "../../../assets/dummy-img.png";
import { handlePostRequest } from "../../../services/PostTemplate";
import moment from "moment";
import "./schedules.css";
import { getSocket, SOCKET_ENDPOINTS } from "../../../services/Socket";
import { handleEncryptData } from "../../../services/EncryptionService";
import { handleDecryptData } from "../../../services/DecryptionService";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { MultiSelect } from "primereact/multiselect";
import DriverRide from "./DriverRide";
import { Socket } from "socket.io-client";

const Schedules = () => {
    const [page, setPage] = useState(0);
    const [hasMoreData, setHasMoreData] = useState(true);

    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [isActiveNowRide, setIsActiveNowRide] = useState(true);
    const [date, setDate] = useState();
    const [fromTime, setFromTime] = useState();
    const [toTime, setToTime] = useState();
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();

    const [day, setDay] = useState();
    const [isRecursive, setIsRecursive] = useState(false);
    const [data, setData] = useState([]);
    const [scheduleList, setScheduleList] = useState([]);
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const userId = useSelector((state) => state.authenticationSlice?.userId) || localStorage.getItem("userId");
    const userType = useSelector((state) => state.authenticationSlice?.userType) || localStorage.getItem("userType");
    const vehicleId = localStorage.getItem("vehicleId");
    const selectedUserType = useSelector((state) => state.authenticationSlice?.selectedUserType);
    const history = useHistory();
    const dispatch = useDispatch();
    const [dialogVisible, setDialogVisible] = useState(false); // State to control dialog visibility
    const socket = getSocket();
    const handleScheduleList = async (currentPage) => {
        // setLoading(true);

        try {
            let apiEndpoint = "";
            let payload = "";
            if (selectedUserType == "1") {
                payload = {
                    userId: userId,
                    isDriver: true,
                    page: currentPage,
                };
                apiEndpoint = `api/route/driverroutes?page=${currentPage}`;
            } else {
                apiEndpoint = `api/scheduleride/getuserschedules?page=${currentPage}`;
                payload = {
                    userId: userId,
                    isDriver: false,
                    page: currentPage,
                };
            }

            if (apiEndpoint) {
                const response = await dispatch(handlePostRequest(apiEndpoint, payload, true, true));
                const fetchedData = response?.data?.data || [];
                setScheduleList((prevList) => [...prevList, ...fetchedData]);
                setHasMoreData(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    //    routeId: response.data.driverrequest.id
    //     scheduleId: _id

    const loadMoreData = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        handleScheduleList(nextPage);
    };

    useEffect(() => {
        socket.on(SOCKET_ENDPOINTS.NEW_REQUEST, (data) => {
            console.log(data, "res data");
            try {
                // Attempt decryption within the listener
                const decryptedResponse = handleDecryptData(data?.cipher); // Ensure you have a decrypt utility
            } catch (error) {
                console.error("Error while decrypting data:", error);
            }
        });

        // Cleanup the socket listener when the component unmounts
        // return () => {
        //     socket.off('passengerRideCancellationListener');
        // };
    }, []);
    useEffect(() => {
        if (socket) {
            const passengerRideCancellationHandler = (response) => {
                console.log("Passenger Ride Cancellation Listener:", response);
            };

            const refreshDriverRoutesHandler = (response) => {
                console.log("Refresh Driver Routes Listener:", response);
                handleScheduleList(0);
            };

            const refreshDashboardHandler = (response) => {
                console.log("Refresh Dashboard Listener:", response);
                handleScheduleList(0);
            };

            // Register event listeners
            socket.on(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, passengerRideCancellationHandler);
            socket.on(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, refreshDriverRoutesHandler);
            socket.on(SOCKET_ENDPOINTS.REFRESH_DASHBOARD, refreshDashboardHandler);

            // Cleanup function to remove listeners
            return () => {
                socket.off(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, passengerRideCancellationHandler);
                socket.off(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, refreshDriverRoutesHandler);
                socket.off(SOCKET_ENDPOINTS.REFRESH_DASHBOARD, refreshDashboardHandler);
            };
        }
    }, [socket, handleScheduleList]); // Dependencies

    useEffect(() => {
        handleScheduleList(0);
    }, []);

    const handleCancelReqPessanger = (routeId, data) => {
        if (!routeId) {
            console.error("Route ID or User ID is missing!");
            return;
        }

        const encryptedData = {
            routeId: data?.request?.[0]?._id,
            scheduleId: routeId,
            // reason: "Driver Cancelled the Ride",
        };

        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");
        // Emit the socket event
        socket.emit("cancelRequestByPassenger", JSON.stringify(encryptData), (response) => {
            try {
                const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
                console.log(decryptedResponse, "decryptedResponse");
                if (decryptedResponse?.status == true) {
                    toast.success(decryptedResponse?.msg);
                    window.location.reload();
                } else {
                    toast.error(decryptedResponse?.msg);
                }
            } catch (error) {
                toast.error("An error occurred while processing the request.");
                console.error("Error during cancelRequestByPassenger event:", error);
            }
        });
    };

    const cancelReqPessanger = (routeId, data) => {
        confirmDialog({
            message: "Do you want to cancel this Route?",
            header: "Cancel Confirmation",
            icon: "pi pi-info-circle",
            rejectClassName: "custom-reject-btn",
            reject: () => console.log("cancel"),
            accept: () => handleCancelReqPessanger(routeId, data),
        });
    };

    const handleCancelRoute = (routeId, recurringId, option) => {
        if (!routeId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        console.log(routeId, "routeId");
        const encryptedData = {
            routeId: routeId,
            recurringId: option == "all" ? recurringId : "",
        };

        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");
        // Emit the socket event
        socket.emit("cancelRoute", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse");
            if (decryptedResponse?.status == true) {
                toast.success(decryptedResponse?.msg);

                window.location.reload();
            } else {
                toast.success(decryptedResponse?.msg);
            }
        });

        // Register the refreshDashboardHandler listener
        socket.on(SOCKET_ENDPOINTS.REFRESH_DASHBOARD, (response) => {
            console.log("Refresh Dashboard Listener:", response);
            handleScheduleList(0);
        });
    };

    const confirmCancelRoute = (routeId, recurringId) => {
        console.log("Route ID:", routeId, "Recurring ID:", recurringId);
        confirmDialog({
            message: "Do you want to Cancle this Route?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            rejectClassName: "custom-reject-btn",
            reject: () => console.log("cancel"),
            accept: () => handleCancelRoute(routeId),
        });
    };

    const confirmInProgress = (routeId, data) => {
        confirmDialog({
            message: "Do you want to Check this Route?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            rejectClassName: "custom-reject-btn",
            reject: () => console.log("cancel"),
            accept: () => handleInProgress(routeId, data),
            // accept: () => handleRideScreen(),
        });
    };

    // const handleRideScreen = () => {
    //     history.push("/driver-ride"); // Ensure "/driver-ride" matches the route in your app
    // };

    const handleInProgress = (routeId, data) => {
        if (!routeId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        // console.log(isScheduled, "isScheduled");
        console.log(routeId, "routeId");
        console.log(data?.accepted, "data");
        const encryptedData = {
            routeId: data?.accepted,
            scheduleId: routeId,
        };

        const encryptData = handleEncryptData(encryptedData);
        // Emit the socket event
        socket.emit("activeRide", JSON.stringify(encryptData), async (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse");
            // const apiEndpoint = "api/scheduleride/getmatcheddriver";
            // const payload = {
            //     userId: userId,
            //     // isScheduled: isScheduled,
            //     scheduleId: routeId,
            // };
            // const responses = await dispatch(handlePostRequest(apiEndpoint, payload, true, true));
            // if (responses?.status == 200) {
            history.push({
                pathname: "/passenger-ride",
                state: { data: decryptedResponse },
            });
            // }
            // if (decryptedResponse?.status == true) {
            //     toast.success(decryptedResponse?.msg);

            //     handleScheduleList(0); // Reset the list
            // } else {
            //     toast.success(decryptedResponse?.msg);
            // }
        });
    };

    const handleStartRoute = (routeId) => {
        if (!routeId || !userId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        console.log("handleStartRoute routeId", routeId);
        const encryptedData = {
            routeId: routeId,
            userId: userId,
        };
        const encryptData = handleEncryptData(encryptedData);
        // Emit the socket event
        socket.emit("start", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse Start");

            if (!decryptedResponse?.activeRide && (!decryptedResponse?.pendingList || decryptedResponse?.pendingList.length == 0)) {
                console.log("No record");
            } else {
                // Redirect to driver-ride with data
                history.push({
                    pathname: "/driver-ride",
                    state: { data: decryptedResponse, routeId },
                });
            }

            // Register additional listeners
            socket.on(SOCKET_ENDPOINTS.REFRESH_SCHEDULE, (response) => {
                console.log("Refresh Schedule Listener:", response);
                handleScheduleList(0);
            });

            socket.on(SOCKET_ENDPOINTS.REFRESH_DASHBOARD, (response) => {
                console.log("Refresh Dashboard Listener:", response);
                handleScheduleList(0);
            });

            socket.on(SOCKET_ENDPOINTS.REDIRECT_PASSENGER_TO_ACTIVE_RIDE, (response) => {
                console.log("Redirect Passenger To Active Ride Listener:", response);
                handleScheduleList(0);
            });

            socket.on(SOCKET_ENDPOINTS.AUTO_COMPLETED_ROUTE, (data) => {
                console.log("AutoComplete", data);
            });
        });
    };

    const confirmStartRoute = (routeId) => {
        confirmDialog({
            message: "Do you want to Start this Route?",
            header: "Start Confirmation",
            icon: "pi pi-info-circle",
            rejectClassName: "custom-reject-btn",
            reject: () => console.log("cancel"),
            accept: () => handleStartRoute(routeId),
        });
    };

    const handleFinishRoute = async (routeId) => {
        if (!routeId) {
            console.error("Route ID is missing!");
            return;
        }

        const encryptedData = {
            routeId: routeId,
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");

        try {
            socket.emit("finishRide", JSON.stringify(encryptData), (response) => {
                const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
                console.log(decryptedResponse, "decryptedResponse Start");

                if (!decryptedResponse) {
                    console.log("No record");
                } else {
                    console.log("Active Ride:", decryptedResponse);
                    // Redirect to driver-ride with data
                    window.location.reload();
                }
            });
        } catch (error) {
            console.error("Error during finishRide event:", error);
        }
    };

    const confirmFinishRoute = (routeId) => {
        confirmDialog({
            message: "Do you want to Finish this Route?",
            header: "Start Confirmation",
            icon: "pi pi-info-circle",
            rejectClassName: "custom-reject-btn",
            reject: () => console.log("cancel"),
            accept: () => handleFinishRoute(routeId),
        });
    };

    // Function to show the confirmation dialog
    const confirmDelete = (routeId, recurringId) => {
        confirmDialog({
            message: "Do you want to delete this Route?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            footer: () => (
                <div>
                    <Button label="Cancel" icon="pi pi-times" onClick={() => toast.error("Deletion cancelled")} className="p-button-text p-button-danger" />
                    <Button label="Selected" icon="pi pi-check" onClick={() => handleDeleteRoute(routeId, "selected")} className="p-button-success" />
                    {/* <Button label="All" icon="pi pi-trash" onClick={() => handleDeleteRoute(routeId, "all", recurringId)} className="p-button-warning" /> */}
                </div>
            ),
        });
    };

    const handleDeleteRoute = (routeId, option, recurringId = "") => {
        if (!routeId || !userId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        // Use the dynamic recurringId when deleting all routes
        const encryptedData = {
            routeId: routeId,
            recurringId: option == "all" ? recurringId : "", // Pass recurringId only when deleting all
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");
        // Emit the socket event
        socket.emit("deleteRoute", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse Start");
            window.location.reload();
            if (decryptedResponse?.status == true) {
                toast.success(decryptedResponse?.msg);
                // Call the refreshDriverRoutes listener
                socket.emit(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES);
                // handleScheduleList()
            } else {
                toast.warn(decryptedResponse?.msg);
            }
        });
    };

    const confirmPassengerDelete = (routeId, recurringId) => {
        console.log("Route ID:", routeId, "Recurring ID:", recurringId);
        confirmDialog({
            message: "Do you want to delete this Route?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            footer: () => (
                <div>
                    <Button label="Cancel" icon="pi pi-times" onClick={() => toast.error("Deletion cancelled")} className="p-button-text p-button-danger" />
                    <Button label="Selected" icon="pi pi-check" onClick={() => handlePassengerDelete(routeId, "selected")} className="p-button-success" />
                    <Button label="All" icon="pi pi-trash" onClick={() => handlePassengerDelete(routeId, "all", recurringId)} className="p-button-warning" />
                </div>
            ),
        });
    };

    const handlePassengerDelete = (routeId, option, recurringId = "") => {
        if (!routeId || !userId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        // Use the dynamic recurringId when deleting all routes
        const encryptedData = {
            scheduleId: routeId,
            recurringId: option == "all" ? recurringId : "", // Pass recurringId only when deleting all
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");
        // Emit the socket event
        socket.emit("deteleSchedule", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse Start");
            if (decryptedResponse?.status == true) {
                toast.success(decryptedResponse?.msg);
                // Call the refreshDriverRoutes listener
                socket.emit(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES);
                window.location.reload();
                // handleScheduleList()
            } else {
                toast.warn(decryptedResponse?.msg);
            }
        });
    };

    // useEffect(() => {
    //     console.log("Socket Listener for Driver Routes Refreshed");
    //     const refreshDriverRoutesListener = () => {
    //         console.log("Driver routes refreshed.");
    //         handleScheduleList(0); // Reset the list
    //     };

    //     const passengerRideCancellationListener = (data) => {
    //         console.log(data, "res data");
    //         try {
    //             const decryptedResponse = handleDecryptData(data?.cipher);
    //             console.log(decryptedResponse, "decryptedResponse");
    //             handleScheduleList(0); // Reset the list
    //         } catch (error) {
    //             console.error("Error while decrypting data:", error);
    //         }
    //     };

    //     if (socket) {
    //         socket.on("refreshDriverRoutes", refreshDriverRoutesListener);
    //         socket.on("passengerRideCancellationListener", passengerRideCancellationListener);
    //         console.log("Socket on");
    //     }

    //     return () => {
    //         if (socket) {
    //             socket.off("refreshDriverRoutes", refreshDriverRoutesListener);
    //             socket.off("passengerRideCancellationListener", passengerRideCancellationListener);
    //             console.log("Socket off");
    //         }
    //     };
    // }, [socket, handleScheduleList]);

    const getScheduleRide = (data) => {
        console.log(data);
        setData(data);
        setIsActiveNowRide(false);
        setVisible(true);
    };
    const handleCloseDialogBox = () => {
        if (!visible) return;
        setVisible(false);
        setIsActiveNowRide(false);
    };

    const handleSchdeuleRide = async () => {
        try {
            let apiEndpoint = "";
            let payload = {};

            if (userType == "1") {
                // For UserType 1
                apiEndpoint = "api/route/reSchedule";
                payload = {
                    routeId: data?._id,
                    date: date,
                    vehicleId: vehicleId,
                };
            } else {
                // For other UserType cases
                apiEndpoint = "api/scheduleride/reschedule";
                payload = {
                    scheduleId: data?._id,
                    date: date,
                    startTime: data?.startTime, // Ensure startTime is available
                    endTime: data?.endTime, // Ensure endTime is available
                };
            }

            if (apiEndpoint) {
                const response = await dispatch(handlePostRequest(apiEndpoint, payload, true, true));
                console.log("API Response:", response);

                if (response?.status == 200) {
                    toast.success(response?.data?.msg);
                    setVisible(false);
                    // Reset the schedule list
                    // window.location.reload();
                }
            }
        } catch (error) {
            console.error("Error scheduling ride:", error);
        } finally {
            // Any cleanup logic here
        }
    };

    const daysLov = [
        { name: "Monday", value: 1 },
        { name: "Tuesday", value: 2 },
        { name: "Wednesday", value: 3 },
        { name: "Thursday", value: 4 },
        { name: "Friday", value: 5 },
        { name: "Saturday", value: 6 },
        { name: "Sunday", value: 7 },
    ];

    return (
        <div className="custom-schedules-grid">
            <ConfirmDialog />
            {scheduleList?.length ? (
                <>
                    {scheduleList?.map((data) => (
                        <div key={data?._id} className="surface-card p-3">
                            <div className="flex flex-row p-ai-center justify-content-between">
                                <div className="flex flex-row p-ai-center">
                                    <Avatar image={data?.userId?.profileImage ? `${baseURL}${data?.userId?.profileImage}` : defaultImg} size="large" shape="circle" style={{ backgroundColor: "inherit" }} />
                                    <div className="ml-3">
                                        <div className="p-text-bold mb-1 mt-3" style={{ fontWeight: "bold" }}>
                                            {data?.userId?.firstName + " " + data?.userId?.lastName}
                                        </div>
                                        <Rating value={data?.userId?.totalRating} readOnly stars={data?.userId?.totalRatingCount} cancel={false} />
                                    </div>
                                </div>
                                <div className="flex flex-column p-2">
                                    {data.status === "started" ? (
                                        <div className="flex flex-row">
                                            <i className="pi pi-user mr-2" style={{ color: "green" }}></i>
                                            <span style={{ color: "green" }}>{data?.status}</span>
                                        </div>
                                    ) : (
                                        ""
                                    )}

                                    {data.status === "active" || data.status === "pending" || data.status === "started" ? (
                                        <span
                                            className="mt-2"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                history.push({
                                                    pathname: "./request-status",
                                                    state: {
                                                        rowData: data,
                                                    },
                                                });
                                            }}
                                        >
                                            {" "}
                                            {selectedUserType === "1" ? "View Pessengers" : " View Owners"}
                                        </span>
                                    ) : (
                                        <div className="flex flex-row">
                                            <i className="pi pi-user mr-2"></i>
                                            <span>{data?.status}</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <hr className="my-3" />
                            <div className="flex flex-row justify-content-between items-center">
                                <div className="flex align-items-center text-white text-md">Date & Time</div>
                                <div className="flex align-items-center justify-content-between flex-wrap ml-2">
                                    <div className="flex align-items-center">
                                        <span className="font-semibold">{moment(data?.date).format("Do MMM, YYYY hh:mm A")}</span>
                                    </div>
                                    {/* <h6 className='my-1'>Date & Time</h6>
                            <div className='flex align-items-center'>
                                <span className='font-semibold'>{data?.date}</span>
                                <span className='mx-2 font-semibold'>{data?.time}</span>
                            </div> */}
                                </div>
                            </div>

                            <div className="flex flex-row justify-content-between mt-1">
                                <Timeline
                                    value={[
                                        { status: data?.startPoint?.placeName ? data?.startPoint?.placeName : "Not found", icon: "pi pi-map-marker" },
                                        { status: data?.endPoint?.placeName ? data?.endPoint?.placeName : "Not found", icon: "pi pi-flag" },
                                    ]}
                                    align="left"
                                    className="custom-timeline"
                                    marker={(item) => (
                                        <span className={`p-timeline-event-icon p-pt-2 text-white`}>
                                            <i className={item?.icon} style={{ fontSize: "1.5rem" }}></i>
                                        </span>
                                    )}
                                    content={(item) => (
                                        <div className="flex flex-column">
                                            <span>{item?.status}</span>
                                        </div>
                                    )}
                                />
                            </div>

                            <hr className="my-1" />
                            <div className="flex flex-column justify-content-between table-container">
                                <div className="table-row">
                                    <div className="text-sm text-center">Distance</div>
                                    <div className="text-sm text-center">Match</div>
                                    <div className="text-sm text-center">Requests</div>
                                    <div className="text-sm text-center">Duration</div>
                                    <div className="text-sm text-center">Gender</div>
                                    <div className="text-sm text-center">Booked</div>
                                </div>
                            </div>

                            <div className="flex flex-column justify-content-between m-3 mt-0">
                                <div className="table-row">
                                    <div className="text-sm text-center">{data?.distance ? `${(data.distance / 1000).toFixed(2)} km` : "0 km"}</div>
                                    <div className="text-sm text-center">{data?.matchedCount || data?.matchCount || 0}</div>
                                    <div className="text-sm text-center">{data?.requestCount || data?.requestedCount || 0}</div>
                                    <div className="text-sm text-center">{data?.duration ? `${Math.floor(data.duration / 3600)}h ${Math.floor((data.duration % 3600) / 60)}m` : "0h 0m"}</div>
                                    <div className="text-sm text-center">{data?.gender}</div>
                                    <div className="text-sm text-center">{data?.bookedSeats || 0}</div>
                                </div>
                            </div>

                            <div>
                                {selectedUserType == 1 ? (
                                    <>
                                        {selectedUserType == 1 && data?.status == "active" && (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Button
                                                    label="Cancel"
                                                    type="button"
                                                    onClick={() => {
                                                        confirmCancelRoute(data?._id, data);
                                                    }}
                                                    className="p-button p-button-danger block font-medium m-2 text-lg w-9rem"
                                                />
                                                <Button
                                                    label="Start"
                                                    onClick={() => {
                                                        confirmStartRoute(data?._id);
                                                    }}
                                                    type="button"
                                                    className="block font-medium m-2 text-lg w-9rem"
                                                />
                                            </div>
                                        )}

                                        {selectedUserType == 1 && data?.status == "started" && (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Button
                                                    label="Finish"
                                                    onClick={() => {
                                                        confirmFinishRoute(data?._id);
                                                    }}
                                                    type="button"
                                                    className="p-button-success block font-medium m-2 text-lg w-9rem"
                                                />
                                                <Button
                                                    label="Continue"
                                                    // onClick={() => {
                                                    //     confirmStartRoute(data?._id);
                                                    // }}
                                                    onClick={() => {
                                                        handleStartRoute(data?._id);
                                                    }}
                                                    type="button"
                                                    className="block font-medium m-2 text-lg w-9rem"
                                                />
                                            </div>
                                        )}

                                        {selectedUserType == 1 && (data?.status == "completed" || data?.status == "cancelled") && (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Button label="Delete" onClick={() => confirmDelete(data._id, data.recurringId)} type="button" className="p-button p-button-danger block font-medium m-2 text-lg w-9rem" />
                                                <Button label="Reschedule" onClick={() => getScheduleRide(data)} type="button" className="block font-medium m-2 text-lg w-9rem" />
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {selectedUserType == 2 && data?.status == "active" && (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Button
                                                    label="In Progress"
                                                    type="button"
                                                    onClick={() => {
                                                        confirmInProgress(data?._id, data);
                                                    }}
                                                    className="p-button p-button-danger block font-medium m-2 text-lg w-9rem"
                                                />
                                                {/* <Button
                                                    label="Start"
                                                    onClick={() => {
                                                        confirmStartRoute(data?._id);
                                                    }}
                                                    type="button"
                                                    className="block font-medium m-2 text-lg w-9rem"
                                                /> */}
                                            </div>
                                        )}

                                        {selectedUserType == 2 && data?.status == "accepted" && (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Button
                                                    label="Cancel"
                                                    onClick={() => {
                                                        cancelReqPessanger(data?._id, data);
                                                    }}
                                                    type="button"
                                                    className="p-button-success block font-medium m-2 text-lg w-9rem"
                                                />
                                                {/* <Button label="Continue" type="button" className="block font-medium m-2 text-lg w-9rem" /> */}
                                            </div>
                                        )}

                                        {selectedUserType == 2 && (data?.status == "completed" || data?.status == "cancelled") && (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Button label="Delete" onClick={() => confirmPassengerDelete(data._id, data.recurringId)} type="button" className="p-button p-button-danger block font-medium m-2 text-lg w-9rem" />
                                                <Button label="Reschedule" onClick={() => getScheduleRide(data)} type="button" className="block font-medium m-2 text-lg w-9rem" />
                                            </div>
                                        )}
                                        {selectedUserType == 2 && data?.status == "pending" && (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Button label="Delete" onClick={() => confirmPassengerDelete(data._id, data.recurringId)} type="button" className="p-button p-button-danger block font-medium m-2 text-lg w-9rem" />
                                                {/* <Button label="Reschedule" onClick={() => getScheduleRide(data)} type="button" className="block font-medium m-2 text-lg w-9rem" /> */}
                                                {/* <Button label="Reschedule" onClick={() => getScheduleRide(data)} type="button" className="block font-medium m-2 text-lg w-9rem" /> */}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                    <Dialog className="surface-card dialog-card" header="Schedule Ride" visible={visible} onHide={handleCloseDialogBox}>
                        <div className="flex align-items-center mb-4">
                            <label id="checkbox" className="mr-2">
                                Is Recursive
                            </label>
                            <Checkbox id="checkbox" onChange={(e) => setIsRecursive(e.checked)} checked={isRecursive}></Checkbox>
                        </div>
                        {isRecursive ? (
                            <>
                                <div className="grid mb-3">
                                    <div className="col-12">
                                        <label id="fromDate" name="fromDate" className="text-white font-semibold">
                                            From Date
                                        </label>
                                        <Calendar id="fromDate" name="fromDate" showIcon showTime showSeconds value={fromDate} placeholder="From Date " onChange={(e) => setFromDate(e.target.value)} className="input-calendar w-full mt-2" />
                                    </div>
                                    <div className="col-12">
                                        <label id="toDate" name="toDate" className="text-white font-semibold">
                                            To Date
                                        </label>
                                        <Calendar id="toDate" name="toDate" showIcon showTime showSeconds value={toDate} placeholder="To Date" onChange={(e) => setToDate(e.target.value)} className="input-calendar w-full mt-2" />
                                    </div>
                                    <div className="col-12">
                                        <label id="day" name="day" className="text-white font-semibold">
                                            Days
                                        </label>
                                        <MultiSelect id="day" name="day" value={day} onChange={(e) => setDay(e.value)} options={daysLov} optionLabel="name" display="chip" placeholder="Select Days" className="w-full mt-2 p-1" />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="grid mb-3">
                                    <div className="col-12 mb-4">
                                        <label id="date" name="date" className="text-white font-semibold">
                                            Date
                                        </label>
                                        <Calendar id="date" name="date" showIcon value={date} onChange={(e) => setDate(e.target.value)} placeholder="Enter Date" className="input-calendar w-full mt-2" />
                                    </div>
                                    {selectedUserType === "1" ? (
                                        ""
                                    ) : (
                                        <>
                                            <label className="col-12 py-0 text-white font-semibold">Search ride in between</label>
                                            <div className="col-6 py-0">
                                                <Calendar id="fromTime" name="fromTime" showIcon value={fromTime} placeholder="From Time" onChange={(e) => setFromTime(e.target.value)} timeOnly icon={() => <i className="pi pi-clock" />} className="input-calendar w-full mt-2" />
                                            </div>
                                            <div className="col-6 py-0">
                                                <Calendar id="toTime" name="toTime" showIcon value={toTime} placeholder="To Time" onChange={(e) => setToTime(e.target.value)} timeOnly icon={() => <i className="pi pi-clock" />} className="input-calendar w-full mt-2" />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </>
                        )}

                        <Button className="block mx-auto mt-5" type="button" label="Schedule" onClick={handleSchdeuleRide}></Button>
                    </Dialog>
                </>
            ) : (
                <h5 style={{ fontStyle: "italic" }}>No Schedule List Found</h5>
            )}
            {hasMoreData && !loading && (
                <button onClick={loadMoreData} className="p-button" style={{ display: "block", margin: "auto" }}>
                    Load More
                </button>
            )}
        </div>
    );
};

export default Schedules;
